import {Injectable, OnDestroy} from '@angular/core';
import {PaymentRequestModel} from '../../api/entity/paymentRequest.model';
import {PaymentRequestRepository} from './ngrx/PaymentRequest.repository';
import {PaymentRequestDataServiceAdapter} from './ngrx/PaymentRequestDataService.adapter';
import {AbstractFindManyPaginatedService} from '../../../../../core/service/v2/service/findmany/abstractFindManyPaginated.service';
import {PaymentRequestSummaryModel} from "../../api/entity/paymentRequestSummary.model";
import {PaymentRequestSummaryDataServiceAdapter} from "./ngrx/paymentRequestSummaryDataService.adapter";
import {AbstractFindAllService} from "../../../../../core/service/v2/service/findAll/abstractFindAll.service";

@Injectable()
export class PaymentRequestSummaryFindAllService extends AbstractFindAllService<PaymentRequestModel, PaymentRequestSummaryModel>
    implements OnDestroy{

    constructor(repository: PaymentRequestRepository, dataServiceAdapter: PaymentRequestSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    resolveSortKeyLabel(value: string): string {
        switch (value) {
            case 'date':
                return 'Date';
            case 'createdAt':
                return 'Date de création';
            case 'partner.name':
                return 'Nom du patient';
            case 'status':
                return 'Statut';
        }
        return value;
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }
}
